import React from 'react';
import { Link } from 'react-router-dom';
import {
  UsersIcon,
  UserPlusIcon,
  ClipboardDocumentListIcon,
  HeartIcon,
  BeakerIcon,
  CameraIcon,
  PresentationChartBarIcon,
} from '@heroicons/react/24/outline';

interface QuickActionsProps {
  userRole: string;
}

export const QuickActions: React.FC<QuickActionsProps> = ({ userRole }) => {
  const actions = [
    { title: 'Register Patient', desc: 'Add new patient', href: '/patients/register', icon: UserPlusIcon, color: 'bg-blue-500', roles: ['admin', 'nurse', 'doctor'] },
    { title: 'Find Patient', desc: 'Search records', href: '/patients/search', icon: UsersIcon, color: 'bg-emerald-500', roles: ['admin', 'nurse', 'doctor', 'pharmacist'] },
    { title: 'Nursing Assessment', desc: 'Patient triage', href: '/perawat/assessment', icon: HeartIcon, color: 'bg-rose-500', roles: ['admin', 'nurse'] },
    { title: 'Doctor Exam', desc: 'Medical examination', href: '/medical/doctor/examination', icon: ClipboardDocumentListIcon, color: 'bg-purple-500', roles: ['admin', 'doctor'] },
    { title: 'Prescriptions', desc: 'Manage Rx', href: '/medical/doctor/prescriptions', icon: ClipboardDocumentListIcon, color: 'bg-indigo-500', roles: ['admin', 'doctor', 'pharmacist'] },
    { title: 'Laboratory', desc: 'Lab tests', href: '/laboratory', icon: BeakerIcon, color: 'bg-amber-500', roles: ['admin', 'lab-technician', 'doctor'] },
    { title: 'Radiology', desc: 'Images & reports', href: '/radiology', icon: CameraIcon, color: 'bg-cyan-500', roles: ['admin', 'radiographer', 'doctor'] },
    { title: 'Pharmacy', desc: 'Dispense medicine', href: '/pharmacy', icon: HeartIcon, color: 'bg-pink-500', roles: ['admin', 'pharmacist'] },
    { title: 'Reports', desc: 'View analytics', href: '/reports', icon: PresentationChartBarIcon, color: 'bg-slate-700', roles: ['admin', 'manager'] },
  ];

  const filteredActions = actions.filter(a => a.roles.includes(userRole));

  return (
    <div className="mb-8">
      <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center">
        <span className="bg-primary-100 text-primary-700 p-1.5 rounded-lg mr-2">⚡</span> Quick Actions
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
        {filteredActions.map((action) => (
          <Link
            key={action.href}
            to={action.href}
            className="group relative flex flex-col p-4 bg-white rounded-xl shadow-sm hover:shadow-lg border border-gray-100 transition-all duration-300 transform hover:-translate-y-1"
          >
            <div className={`inline-flex p-3 rounded-xl ${action.color} text-white shadow-md mb-3 w-max group-hover:scale-110 transition-transform`}>
              <action.icon className="h-6 w-6" aria-hidden="true" />
            </div>
            <h3 className="text-base font-semibold text-gray-900 group-hover:text-primary-600 transition-colors">
              {action.title}
            </h3>
            <p className="mt-1 text-xs text-gray-500">{action.desc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};
